/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateCommissionPaymentRequest } from '../models/UpdateCommissionPaymentRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommissionPaymentService {
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiCommissionPaymentGetByOrderId(
        orderId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/CommissionPayment/GetByOrderID',
            query: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param status
     * @param teamCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiCommissionPaymentGetAll(
        status?: string,
        teamCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/CommissionPayment/GetAll',
            query: {
                'status': status,
                'teamCode': teamCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiCommissionPaymentUpdateStatusAndPaymentReference(
        orderId: string,
        requestBody?: UpdateCommissionPaymentRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/CommissionPayment/{orderID}/UpdateStatusAndPaymentReference',
            path: {
                'orderID': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiCommissionPaymentUploadTransferReceiptImg(
        orderId: string,
        formData?: {
            Receipt: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CommissionPayment/{orderID}/UploadTransferReceiptImg',
            path: {
                'orderID': orderId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiCommissionPaymentGetTransferReceiptImg(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/CommissionPayment/{orderID}/GetTransferReceiptImg',
            path: {
                'orderID': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
